import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal } from 'react-bootstrap';

function ListarEgresos() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [egresos, setEgresos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [egresoSeleccionadoId, setEgresoSeleccionadoId] = useState(null);
    
    // Modal Vista Previa
    const [showModalVistaPrevia, setShowModalVistaPrevia] = useState(false);
    const [egresoVistaPrevia, setEgresoVistaPrevia] = useState(null);
    const [loadingVistaPrevia, setLoadingVistaPrevia] = useState(false);
    
    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaProveedor, setBusquedaProveedor] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    
    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;

    useEffect(() => {
        const hoy = new Date();
        const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        const finMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
        
        setFechaInicio(inicioMes.toISOString().split('T')[0]);
        setFechaFin(finMes.toISOString().split('T')[0]);

        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Usar el mismo permiso que documento soporte
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'ver_listado_documentos_soporte');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('ver_listado_documentos_soporte')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // Cargar datos iniciales
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setUsuarios(response.data);
            })
            .catch(error => console.log('err: ' + error));

    }, []);

    const totalesEgresos = useMemo(() => {
        let valor = 0;
        let activos = 0;
        let anulados = 0;
        egresos.forEach(e => {
            valor += parseFloat(e.valor_total || 0);
            if (Number(e.estado) === 0) activos++;
            else if (Number(e.estado) === 1) anulados++;
        });
        return { conteo: egresos.length, valor, activos, anulados };
    }, [egresos]);

    const ejecutarCarga = useCallback((proveedorQuery) => {
        if (!fechaInicio || !fechaFin) return;

        const userdata = JSON.parse(localStorage.getItem('userdata'));
        const params = {
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            usuario_id: usuarioFiltro || null,
            busqueda_proveedor: proveedorQuery || null,
            estado: estadoFiltro !== '' ? estadoFiltro : null
        };

        axios.get('/egresos', { params })
            .then(response => {
                if (response.status === 200) {
                    setEgresos(response.data);
                    setPaginaActual(1);
                }
            })
            .catch(error => {
                console.error('Error al buscar egresos:', error);
                alert('Error al buscar egresos: ' + (error.response?.data?.message || error.message));
            });
    }, [fechaInicio, fechaFin, usuarioFiltro, estadoFiltro]);

    const ejecutarCargaRef = useRef(ejecutarCarga);
    ejecutarCargaRef.current = ejecutarCarga;

    useEffect(() => {
        if (!hasPermission || !loggedIn || !fechaInicio || !fechaFin) return;
        ejecutarCargaRef.current(busquedaProveedor);
    }, [hasPermission, loggedIn, fechaInicio, fechaFin, usuarioFiltro, estadoFiltro]);

    useEffect(() => {
        if (!hasPermission || !loggedIn || !fechaInicio || !fechaFin) return;
        const timeoutId = setTimeout(() => ejecutarCargaRef.current(busquedaProveedor), 500);
        return () => clearTimeout(timeoutId);
    }, [busquedaProveedor]);

    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, busquedaProveedor]);

    const buscarEgresos = () => {
        if (!fechaInicio || !fechaFin) {
            alert('Por favor seleccione las fechas de inicio y fin');
            return;
        }
        ejecutarCarga(busquedaProveedor);
    };

    const anularEgreso = (id, estado) => {
        if (estado === 1) {
            alert('Este egreso ya está anulado');
            return;
        }

        if (!window.confirm('¿Está seguro de anular este egreso?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        axios.put(`/egreso/${id}/anular?uid=${userdata.user_id}`)
            .then(response => {
                if (response.status === 200) {
                    alert('Egreso anulado exitosamente');
                    buscarEgresos(); // Recargar la lista
                }
            })
            .catch(error => {
                console.error('Error al anular egreso:', error);
                alert('Error al anular egreso: ' + (error.response?.data?.message || error.message));
            });
    };

    const getEstadoTexto = (estado) => {
        switch(estado) {
            case 0: return 'Generada';
            case 1: return 'Anulada';
            default: return 'Desconocido';
        }
    };

    const pillBase = { borderRadius: '10px', fontWeight: 700, fontSize: '0.7rem', padding: '6px 10px', display: 'inline-block' };
    const getEstadoPillStyle = (estado) => {
        if (Number(estado) === 0) return { ...pillBase, background: 'rgba(40,167,69,0.1)', color: '#28a745', border: '1px solid rgba(40,167,69,0.25)' };
        return { ...pillBase, background: 'rgba(220,53,69,0.1)', color: '#dc3545', border: '1px solid rgba(220,53,69,0.25)' };
    };
    const docSoportePillStyle = { ...pillBase, background: 'rgba(23,162,184,0.1)', color: '#117f90', border: '1px solid rgba(23,162,184,0.22)' };

    const formatearFecha = (fecha) => {
        return new Date(fecha).toLocaleDateString('es-CO');
    };

    const formatearMoneda = (valor) => {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0
        }).format(valor);
    };

    const getEgresosPaginados = () => {
        const inicio = (paginaActual - 1) * registrosPorPagina;
        const fin = inicio + registrosPorPagina;
        return egresos.slice(inicio, fin);
    };

    const getPaginationItems = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
        if (current <= 3) return [1, 2, 3, 4, null, total];
        if (current >= total - 2) return [1, null, total - 3, total - 2, total - 1, total];
        return [1, null, current - 1, current, current + 1, null, total];
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    const totalPaginas = Math.max(0, Math.ceil(egresos.length / registrosPorPagina));
    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;

    const handleSeleccionEgreso = (egresoId) => {
        setEgresoSeleccionadoId(egresoSeleccionadoId === egresoId ? null : egresoId);
    };

    const getEgresoSeleccionado = () => {
        return egresos.find(e => e.id === egresoSeleccionadoId);
    };

    const abrirVistaPrevia = async () => {
        if (!egresoSeleccionadoId) return;
        
        setLoadingVistaPrevia(true);
        setShowModalVistaPrevia(true);
        
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            
            const [clienteResponse, egresoResponse] = await Promise.all([
                axios.get(`/get-client?uid=${userdata.user_id}`),
                axios.get(`/egreso/${egresoSeleccionadoId}?uid=${userdata.user_id}`)
            ]);

            const egresoData = egresoResponse.data;
            
            // Cargar encabezado personalizado si existe
            let encabezadoPersonalizado = null;
            if (egresoData.users_id) {
                try {
                    const encabezadoResponse = await axios.get(`/encabezado-personalizado?uid=${egresoData.users_id}`);
                    if (encabezadoResponse.status === 200 && encabezadoResponse.data && encabezadoResponse.data.estado === 1) {
                        encabezadoPersonalizado = encabezadoResponse.data;
                    }
                } catch (error) {
                    console.log('No hay encabezado personalizado');
                }
            }

            setEgresoVistaPrevia({
                egreso: egresoData,
                client: clienteResponse.data,
                encabezadoPersonalizado: encabezadoPersonalizado
            });
            
        } catch (error) {
            console.error('Error al cargar vista previa:', error);
            alert('Error al cargar la vista previa del egreso');
            setShowModalVistaPrevia(false);
        } finally {
            setLoadingVistaPrevia(false);
        }
    };

    const cerrarVistaPrevia = () => {
        setShowModalVistaPrevia(false);
        setEgresoVistaPrevia(null);
    };

    const imprimirVistaPrevia = () => {
        const contenido = document.querySelector('.modal-body').innerHTML;
        const ventana = window.open('', '_blank');
        ventana.document.write(`
            <html>
                <head>
                    <title>Egreso N° ${egresoVistaPrevia?.egreso?.numero}</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        table { border-collapse: collapse; width: 100%; }
                        th, td { border: 1px solid #dee2e6; padding: 8px; }
                        @media print {
                            body { margin: 0; }
                        }
                    </style>
                </head>
                <body>
                    ${contenido}
                </body>
            </html>
        `);
        ventana.document.close();
        ventana.print();
    };

    const descargarPDFVistaPrevia = async () => {
        try {
            const html2pdf = await import('html2pdf-fix-jspdf');
            const element = document.querySelector('.modal-body');
            
            const opt = {
                margin: 10,
                filename: `egreso-${egresoVistaPrevia?.egreso?.numero}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                }
            };
            
            await html2pdf.default().from(element).set(opt).save();
            
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
        }
    };

    return (
        <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
            <style>{`
                .summary-card { background: #fff; padding: 1.25rem; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); border: none; transition: transform 0.2s; height: 100%; }
                .summary-card:hover { transform: translateY(-3px); }
                .icon-box { width: 45px; height: 45px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; margin-right: 15px; }
                .card-label { color: #8c8c8c; font-size: 0.75rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
                .card-value { font-size: 1.25rem; font-weight: 700; color: #323a45; }
                .card-subtext { font-size: 0.65rem; color: #bababa; margin-top: 2px; }
                .filter-card { background: #fff; border-radius: 12px; border: none; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05); }
                .custom-table { width: 100%; background: #fff; border-radius: 12px; overflow: hidden; }
                .custom-table thead th {
                    background: #f8f9fa; color: #7d7d7d !important; text-transform: uppercase; font-size: 0.7rem !important;
                    font-weight: 700 !important; padding: 12px 15px !important; border: none !important;
                }
                .custom-table tbody tr { border-bottom: 1px solid #f0f0f0; transition: all 0.2s; cursor: pointer; }
                .custom-table tbody tr:hover { background-color: #f9fbff !important; box-shadow: inset 4px 0 0 #17a2b8; }
                .custom-table td { padding: 10px 15px !important; vertical-align: middle !important; border: none !important; font-size: 0.8rem !important; }
                .table-info { background-color: #f6fcfd !important; box-shadow: inset 4px 0 0 #17a2b8 !important; }
                .egreso-actions-card .card-header { background: #f8f9fa; border-bottom: 1px solid #eef0f2; }
            `}</style>
            <Header client={client} />
            <Aside client={client} activelink="billing" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                    <li className="breadcrumb-item active">Listado de Egresos</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-center">
                            <div className="col-sm-12 col-md-8">
                                <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Listado de Egresos</h1>
                                <p className="mb-0 mt-1 text-muted" style={{ fontSize: '0.8rem' }}>
                                    <span className="badge" style={{ background: 'rgba(23,162,184,0.1)', color: '#117f90', border: '1px solid rgba(23,162,184,0.2)', borderRadius: '999px', fontWeight: 700, fontSize: '0.72rem' }}>{egresos.length} registros</span>
                                </p>
                            </div>
                            <div className="col-sm-12 col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/crear-egreso" className="btn btn-primary" style={{ borderRadius: '10px', padding: '7px 18px', fontSize: '0.9rem' }}>
                                    <i className="fas fa-plus mr-2"></i> Crear Egreso
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        <div className="row mb-4">
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{ background: 'rgb(240, 245, 255)', color: 'rgb(123 136 145)' }}><i className="fas fa-file-invoice-dollar"></i></div>
                                    <div><div className="card-label">Egresos</div><div className="card-value">{totalesEgresos.conteo}</div><div className="card-subtext">En el periodo filtrado</div></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{ background: 'rgb(230, 247, 255)', color: '#17a2b8' }}><i className="fas fa-dollar-sign"></i></div>
                                    <div><div className="card-label">Valor total</div><div className="card-value">{formatearMoneda(totalesEgresos.valor)}</div><div className="card-subtext">Suma de totales</div></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{ background: '#f6ffed', color: '#52c41a' }}><i className="fas fa-check-circle"></i></div>
                                    <div><div className="card-label">Generadas</div><div className="card-value">{totalesEgresos.activos}</div><div className="card-subtext">Estado vigente</div></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{ background: '#fff1f0', color: '#f5222d' }}><i className="fas fa-ban"></i></div>
                                    <div><div className="card-label">Anuladas</div><div className="card-value">{totalesEgresos.anulados}</div><div className="card-subtext">No válidas</div></div>
                                </div>
                            </div>
                        </div>

                        <div className="filter-card p-4 mb-4">
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="small font-weight-bold text-uppercase text-muted d-block">Fecha inicio *</label>
                                    <input type="date" className="form-control" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} required />
                                </div>
                                <div className="col-md-3">
                                    <label className="small font-weight-bold text-uppercase text-muted d-block">Fecha fin *</label>
                                    <input type="date" className="form-control" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} required />
                                </div>
                                <div className="col-md-2">
                                    <label className="small font-weight-bold text-uppercase text-muted d-block">Usuario</label>
                                    <select className="form-control" value={usuarioFiltro} onChange={(e) => setUsuarioFiltro(e.target.value)}>
                                        <option value="">Todos</option>
                                        {usuarios.map(usuario => (
                                            <option key={usuario.id} value={usuario.id}>{usuario.name} {usuario.lastname}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="small font-weight-bold text-uppercase text-muted d-block">Estado</label>
                                    <select className="form-control" value={estadoFiltro} onChange={(e) => setEstadoFiltro(e.target.value)}>
                                        <option value="">Todos</option>
                                        <option value="0">Generada</option>
                                        <option value="1">Anulada</option>
                                    </select>
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button type="button" className="btn btn-info btn-block" style={{ borderRadius: '10px', fontWeight: 600 }} onClick={buscarEgresos}>
                                        <i className="fas fa-search mr-1"></i> Buscar
                                    </button>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-6">
                                    <label className="small font-weight-bold text-uppercase text-muted d-block">Buscar proveedor</label>
                                    <input type="text" className="form-control" placeholder="Nombre..." value={busquedaProveedor} onChange={(e) => setBusquedaProveedor(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {egresoSeleccionadoId && getEgresoSeleccionado() && (
                            <div className="card egreso-actions-card shadow-sm border-0 mb-4" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                <div className="card-header py-3">
                                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                                        <div className="d-flex align-items-center flex-wrap">
                                            <h5 className="mb-0 mr-3" style={{ fontSize: '1rem', color: '#323a45' }}>
                                                <i className="fas fa-check-circle text-success mr-1"></i>
                                                <strong>Egreso N° {getEgresoSeleccionado()?.numero}</strong>
                                            </h5>
                                        </div>
                                        <button 
                                            className="btn btn-sm btn-outline-secondary mt-2 mt-md-0"
                                            onClick={() => setEgresoSeleccionadoId(null)}
                                        >
                                            <i className="fas fa-times"></i> Deseleccionar
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body py-3">
                                    <div className="btn-toolbar" role="toolbar">
                                        <div className="btn-group mr-2 mb-2" role="group">
                                            <button 
                                                type="button" 
                                                className="btn btn-outline-info"
                                                onClick={abrirVistaPrevia}
                                                title="Ver Vista Previa"
                                            >
                                                <i className="fas fa-eye"></i> Ver Vista Previa
                                            </button>
                                        </div>
                                        {getEgresoSeleccionado()?.estado === 0 && (
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    type="button" 
                                                    className="btn btn-outline-danger"
                                                    onClick={() => anularEgreso(getEgresoSeleccionado().id, getEgresoSeleccionado().estado)}
                                                    title="Anular Egreso"
                                                >
                                                    <i className="fas fa-ban"></i> Anular Egreso
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="card shadow-sm border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                            <div className="card-body p-0" style={{ overflowX: 'auto', minHeight: '280px' }}>
                                <table className="table custom-table mb-0" style={{ minWidth: '920px' }}>
                                    <thead>
                                        <tr>
                                            <th width="56">Sel.</th>
                                            <th>N° Egreso</th>
                                            <th>Fecha</th>
                                            <th>Proveedor</th>
                                            <th className="text-center">Doc. soporte</th>
                                            <th>Usuario</th>
                                            <th className="text-center">Estado</th>
                                            <th className="text-right">Valor total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getEgresosPaginados().map((egreso) => (
                                            <tr 
                                                key={egreso.id}
                                                className={egresoSeleccionadoId === egreso.id ? 'table-info' : ''}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleSeleccionEgreso(egreso.id)}
                                            >
                                                <td className="text-center">
                                                    <input 
                                                        type="radio" 
                                                        name="egresoSeleccionado"
                                                        checked={egresoSeleccionadoId === egreso.id}
                                                        onChange={() => handleSeleccionEgreso(egreso.id)}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </td>
                                                <td className="text-center"><strong>{egreso.numero}</strong></td>
                                                <td className="text-center">{formatearFecha(egreso.fecha_creacion)}</td>
                                                <td>{egreso.nombre_proveedor}</td>
                                                <td className="text-center">
                                                    {egreso.documento_soporte_prefijo && egreso.documento_soporte_numero ? (
                                                        <span style={docSoportePillStyle}>
                                                            {egreso.documento_soporte_prefijo}-{egreso.documento_soporte_numero}
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted">N/A</span>
                                                    )}
                                                </td>
                                                <td>{egreso.usuario_nombre} {egreso.usuario_apellido}</td>
                                                <td className="text-center">
                                                    <span style={getEstadoPillStyle(egreso.estado)}>{getEstadoTexto(egreso.estado)}</span>
                                                </td>
                                                <td className="text-right">
                                                    <strong>{formatearMoneda(egreso.valor_total)}</strong>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {egresos.length === 0 && (
                                    <div className="text-center p-4 text-muted">
                                        <p className="mb-0">No se encontraron egresos para los filtros seleccionados.</p>
                                    </div>
                                )}
                            </div>

                            <div className="card-footer bg-white border-0 py-3">
                                <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: '12px' }}>
                                    <div style={{ color: '#8c8c8c', fontSize: '0.8rem', flex: '1 1 auto' }}>
                                        Mostrando <strong>{egresos.length === 0 ? 0 : indicePrimerRegistro + 1}</strong> a <strong>{Math.min(indiceUltimoRegistro, egresos.length)}</strong> de <strong>{egresos.length}</strong> egresos
                                    </div>
                                    <nav>
                                        <ul className="pagination pagination-sm mb-0" style={{ gap: '5px' }}>
                                            <li className={`page-item ${paginaActual === 1 || totalPaginas === 0 ? 'disabled' : ''}`}>
                                                <button type="button" className="page-link border-0 shadow-sm" onClick={() => setPaginaActual(paginaActual - 1)} disabled={paginaActual === 1 || totalPaginas === 0} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                    <i className="fas fa-chevron-left"></i>
                                                </button>
                                            </li>
                                            {totalPaginas < 1 ? (
                                                <li className="page-item disabled">
                                                    <span className="page-link border-0 shadow-sm" style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#8c8c8c' }}>1</span>
                                                </li>
                                            ) : (
                                                getPaginationItems(paginaActual, totalPaginas).map((item, idx) => {
                                                    if (item === null) {
                                                        return (
                                                            <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                                <span className="page-link border-0 shadow-sm" style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#8c8c8c' }}>...</span>
                                                            </li>
                                                        );
                                                    }
                                                    return (
                                                        <li key={item} className={`page-item ${paginaActual === item ? 'active' : ''}`}>
                                                            <button
                                                                type="button"
                                                                className="page-link border-0 shadow-sm"
                                                                onClick={() => setPaginaActual(item)}
                                                                style={{
                                                                    borderRadius: '8px',
                                                                    padding: '6px 12px',
                                                                    background: paginaActual === item ? '#17a2b8' : '#f8f9fa',
                                                                    color: paginaActual === item ? 'white' : '#323a45',
                                                                    fontWeight: 700,
                                                                    border: 0
                                                                }}
                                                            >
                                                                {item}
                                                            </button>
                                                        </li>
                                                    );
                                                })
                                            )}
                                            <li className={`page-item ${paginaActual === totalPaginas || totalPaginas === 0 ? 'disabled' : ''}`}>
                                                <button type="button" className="page-link border-0 shadow-sm" onClick={() => setPaginaActual(paginaActual + 1)} disabled={paginaActual === totalPaginas || totalPaginas === 0} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                    <i className="fas fa-chevron-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Modal Vista Previa */}
            <Modal 
                show={showModalVistaPrevia} 
                onHide={cerrarVistaPrevia}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-file-invoice mr-2"></i>
                        Vista Previa - Egreso N° {egresoVistaPrevia?.egreso?.numero}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {loadingVistaPrevia ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-info" role="status">
                                <span className="sr-only">Cargando...</span>
                            </div>
                            <p className="mt-3">Cargando vista previa...</p>
                        </div>
                    ) : egresoVistaPrevia ? (
                        <VistaPreviaEgresoContent 
                            egreso={egresoVistaPrevia.egreso}
                            client={egresoVistaPrevia.client}
                            encabezadoPersonalizado={egresoVistaPrevia.encabezadoPersonalizado}
                        />
                    ) : null}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={cerrarVistaPrevia}>
                        <i className="fas fa-times mr-2"></i>
                        Cerrar
                    </button>
                    {egresoVistaPrevia && (
                        <>
                            <button 
                                className="btn btn-dark" 
                                onClick={imprimirVistaPrevia}
                            >
                                <i className="fas fa-print mr-2"></i>
                                Imprimir
                            </button>
                            <button 
                                className="btn btn-danger" 
                                onClick={descargarPDFVistaPrevia}
                            >
                                <i className="fas fa-file-pdf mr-2"></i>
                                Descargar PDF
                            </button>
                            <button 
                                className="btn btn-info" 
                                onClick={() => window.open(`/smile/#/vista-previa-egreso/${egresoVistaPrevia.egreso.id}`, '_blank')}
                            >
                                <i className="fas fa-external-link-alt mr-2"></i>
                                Abrir en Nueva Ventana
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

// Componente para renderizar el contenido de la vista previa
function VistaPreviaEgresoContent({ egreso, client, encabezadoPersonalizado }) {
    const getMetodoPagoTexto = (codigo) => {
        const metodosPago = {
            '10': 'Efectivo',
            '42': 'Consignación bancaria',
            '1': 'Instrumento no definido',
            '20': 'Cheque',
            '30': 'Transferencia Crédito',
            '31': 'Transferencia Débito',
            '45': 'Transferencia Crédito Bancario',
            '47': 'Transferencia Débito Bancaria',
            '48': 'Tarjeta Crédito',
            '49': 'Tarjeta Débito',
            'ZZZ': 'Acuerdo mutuo'
        };
        return metodosPago[codigo] || codigo;
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Anulada';
            default: return 'Desconocido';
        }
    };

    // Calcular totales de descuento e IVA
    const calcularTotales = () => {
        let totalDescuento = 0;
        let totalIVA = 0;
        let subtotal = 0;

        egreso.detalle?.forEach(item => {
            const lineTotal = item.vrunitario * item.cantidad;
            const descuento = lineTotal * (item.descuento / 100);
            const baseImponible = lineTotal - descuento;
            const iva = baseImponible * (item.iva / 100);
            
            subtotal += lineTotal;
            totalDescuento += descuento;
            totalIVA += iva;
        });

        return { subtotal, totalDescuento, totalIVA };
    };

    const { subtotal, totalDescuento, totalIVA } = calcularTotales();

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return `
                <div style="margin-bottom: 20px;">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div style="flex: 0 0 25%; text-align: center;">
                            ${client?.logo ? `<img src="${client.logo}" style="max-width: 150px; max-height: 80px;" />` : ''}
                        </div>
                        <div style="flex: 1; text-align: center;">
                            <h4 style="margin-bottom: 5px;">${client?.nombre || ''}</h4>
                            <address style="margin: 0; font-size: 12px;">
                                ${client?.direccion || ''}<br />
                                ${client?.telefono || ''}<br />
                                Email: ${client?.email || ''}
                            </address>
                        </div>
                        <div style="flex: 0 0 25%;"></div>
                    </div>
                </div>
            `;
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const nombreUsuario = egreso.usuario_nombre && egreso.usuario_apellido 
        ? `${egreso.usuario_nombre} ${egreso.usuario_apellido}` 
        : 'N/A';

    return (
        <div className="p-3" style={{ fontFamily: 'Arial, sans-serif' }}>
            {/* Encabezado Personalizado */}
            <div dangerouslySetInnerHTML={{ __html: generarEncabezadoHTML() }} />

            {/* Banner: EGRESO */}
            <div style={{ marginBottom: '10px', fontFamily: 'Arial, sans-serif' }}>
                <div style={{ backgroundColor: '#e9ecef', padding: '8px 12px', fontWeight: 'bold', fontSize: '13px', borderRadius: '3px', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
                    EGRESO N° {egreso.numero}
                </div>
            </div>

            {/* Datos del Egreso */}
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '15px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>
                <tbody>
                    <tr>
                        <td style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', width: '15%', verticalAlign: 'middle', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>FECHA CREACIÓN</td>
                        <td style={{ backgroundColor: '#ffffff', width: '18%', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>{formatearFecha(egreso.fecha_creacion)}</td>
                        <td style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', width: '15%', verticalAlign: 'middle', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>FORMA DE PAGO</td>
                        <td style={{ backgroundColor: '#ffffff', width: '18%', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>{getMetodoPagoTexto(egreso.forma_pago)}</td>
                        <td style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', width: '15%', verticalAlign: 'middle', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>ESTADO</td>
                        <td style={{ backgroundColor: '#ffffff', width: '19%', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>
                            <span style={{ color: egreso.estado === 0 ? '#28a745' : '#dc3545', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>
                                {getEstadoTexto(egreso.estado)}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', verticalAlign: 'middle', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>CREADO POR</td>
                        <td colSpan="5" style={{ backgroundColor: '#ffffff', padding: '6px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>{nombreUsuario}</td>
                    </tr>
                </tbody>
            </table>

            {/* Datos del Proveedor */}
            <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#f8f9fa', fontSize: '12px', marginBottom: '20px', fontFamily: 'Arial, sans-serif' }}>
                <tbody>
                    <tr>
                        <td style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', width: '15%', verticalAlign: 'middle', padding: '6px', fontSize: '11px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>PROVEEDOR</td>
                        <td style={{ backgroundColor: '#ffffff', width: '35%', padding: '6px', fontSize: '11px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>{egreso.nombre_proveedor}</td>
                        <td style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', width: '15%', verticalAlign: 'middle', padding: '6px', fontSize: '11px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>DOCUMENTO</td>
                        <td style={{ backgroundColor: '#ffffff', width: '35%', padding: '6px', fontSize: '11px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>{egreso.proveedor_documento || 'N/A'}</td>
                    </tr>
                </tbody>
            </table>

            {/* Tabla de Conceptos */}
            <div className="table-responsive">
                <table className="table table-bordered table-hover" style={{ marginBottom: '20px', fontFamily: 'Arial, sans-serif' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#282828', color: '#ffffff' }}>
                            <th style={{ border: '1px solid #dee2e6', padding: '8px', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>Código</th>
                            <th style={{ border: '1px solid #dee2e6', padding: '8px', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>Descripción</th>
                            <th style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'center', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>Cantidad</th>
                            <th style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>Precio Unit.</th>
                            <th style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'center', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>Descuento</th>
                            <th style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'center', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>IVA</th>
                            <th style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {egreso.detalle?.map((item, index) => {
                            const lineTotal = item.vrunitario * item.cantidad;
                            const descuento = lineTotal * (item.descuento / 100);
                            const baseImponible = lineTotal - descuento;
                            const iva = baseImponible * (item.iva / 100);
                            const total = baseImponible + iva;

                            return (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                    <td style={{ border: '1px solid #dee2e6', padding: '8px', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>{item.concepto_pago?.codigo}</td>
                                    <td style={{ border: '1px solid #dee2e6', padding: '8px', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>{item.concepto_pago?.nombre}</td>
                                    <td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'center', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>{item.cantidad}</td>
                                    <td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>${Math.round(parseFloat(item.vrunitario)).toLocaleString('es-CO')}</td>
                                    <td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'center', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>{item.descuento}%</td>
                                    <td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'center', fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>{item.iva}%</td>
                                    <td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right', fontSize: '12px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>${Math.round(total).toLocaleString('es-CO')}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'right', padding: '8px 16px 8px 8px', border: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>Subtotal:</td>
                            <td style={{ textAlign: 'right', padding: '8px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>${Math.round(subtotal).toLocaleString('es-CO')}</td>
                        </tr>
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'right', padding: '8px 16px 8px 8px', border: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>Descuento:</td>
                            <td style={{ textAlign: 'right', padding: '8px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>-${Math.round(totalDescuento).toLocaleString('es-CO')}</td>
                        </tr>
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'right', padding: '8px 16px 8px 8px', border: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>IVA:</td>
                            <td style={{ textAlign: 'right', padding: '8px', border: '1px solid #dee2e6', fontFamily: 'Arial, sans-serif' }}>${Math.round(totalIVA).toLocaleString('es-CO')}</td>
                        </tr>
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'right', padding: '8px 16px 8px 8px', border: '2px solid #dee2e6', fontWeight: 'bold', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Total:</td>
                            <td style={{ textAlign: 'right', padding: '8px', border: '2px solid #dee2e6', fontFamily: 'Arial, sans-serif', fontSize: '14px', fontWeight: 'bold' }}>${Math.round(parseFloat(egreso.valor_total)).toLocaleString('es-CO')}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* Observaciones */}
            {egreso.observaciones && (
                <div style={{ marginTop: '20px', fontFamily: 'Arial, sans-serif' }}>
                    <h6 style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>Observaciones:</h6>
                    <p style={{ fontSize: '12px', fontFamily: 'Arial, sans-serif' }}>{egreso.observaciones}</p>
                </div>
            )}
        </div>
    );
}

export default ListarEgresos;